(function () {
    'use strict';

    angular.module('app.notes', [
        'app.core'
    ]);
})();
